const data = [
  {
    title: "e-commerce",
    demo: "http://ec2-3-142-143-221.us-east-2.compute.amazonaws.com/ecommerce-marketplace",
    github: "https://github.com/Pioryd/ecommerce-marketplace",
    photo: "ecommerce-marketplace.png",
    parts: [
      {
        name: "Server",
        tools: [
          "Node.js",
          "JavaScript",
          "Express",
          "REST",
          "MongoDB",
          "JWT",
          "Jest"
        ]
      },
      {
        name: "Client",
        tools: [
          "React",
          "JavaScript",
          "REST",
          "Redux",
          "Jest",
          "Cypress",
          "html/sass"
        ]
      }
    ]
  },
  {
    title: "Admin panel",
    demo: "http://ec2-3-142-143-221.us-east-2.compute.amazonaws.com/admin-panel-reception",
    github: "https://github.com/Pioryd/admin-panel-reception",
    photo: "admin-panel-reception.png",
    parts: [
      {
        name: "Server",
        tools: ["Node.js", "TypeScript", "Express", "GraphQL", "TypeORM"]
      },
      {
        name: "Client",
        tools: ["React", "TypeScript", "GraphQL", "Apollo", "Material-UI"]
      }
    ]
  },
  {
    title: "Chat online",
    demo: "http://ec2-3-142-143-221.us-east-2.compute.amazonaws.com/chat-online",
    github: "https://github.com/Pioryd/chat-online",
    photo: "chat-online.png",
    parts: [
      {
        name: "Server",
        tools: ["Node.js", "TypeScript", "Express", "WebSocket"]
      },
      {
        name: "Client",
        tools: ["React", "TypeScript", "WebSocket", "Bootstrap"]
      }
    ]
  },
  {
    title: "Web (portfolio)",
    demo: "https://pioryd.github.io/",
    github: "https://github.com/Pioryd/pioryd.github.io",
    photo: "web-portfolio.png",
    parts: [
      {
        name: "Client",
        tools: ["React", "JavaScript", "Material-UI"]
      }
    ]
  },
  {
    title: "CMS (C++ Modular Scripting)",
    github: "https://github.com/Pioryd/cms",
    photo: "python.png",
    parts: [
      {
        name: "Lib",
        tools: ["Python", "C++17"]
      }
    ]
  },
  {
    title: "Framework for modular scripting client-server application.",
    github: "https://github.com/Pioryd/framework",
    photo: "cpp.png",
    parts: [
      {
        name: "Framework",
        tools: [
          "C++17",
          "Boost::Asio",
          "SFML",
          "TGUI",
          "Mysql",
          "MariaDB",
          "Sqlite"
        ]
      }
    ]
  }
];

export default data;
